// The lead page for a call's patient. Its own small module so the bell (header) can use it
// without loading the call pill.
import { PATH_DASHBOARD } from '../../routes/paths';

export const patientPath = (practiceId, leadId) => PATH_DASHBOARD.general.leadDetail
    .replace(':practiceId', practiceId).replace(':id', leadId).replace('/:tab?', '');
